export const SERVICES = [
  {
    slug: "housekeeping",
    code: "01",
    title: "Housekeeping Manpower",
    short: "Housekeeping",
    tagline: "Clean floors. Trained hands. Daily accountability.",
    img: "/img/housekeeping.jpg",
    intro:
      "Trained housekeeping staff for offices, factories, hospitals, hotels, malls and residential complexes — deployed with supervisors, duty rosters and clear daily checklists.",
    includes: [
      "Day, night and rotational shift housekeepers",
      "On-site supervisors and attendance tracking",
      "Washroom, pantry, floor and façade-level cleaning",
      "Deep cleaning and post-event clean-ups",
      "Replacement staff when someone is on leave",
    ],
    faqs: [
      ["Can you supply staff at short notice?", "Yes. Share the site, headcount and shift timings and we will confirm a deployment plan and start date."],
      ["Who manages the staff day to day?", "Our supervisor manages attendance, duties and quality checks, and reports to your facility contact."],
      ["Are statutory obligations covered?", "Staff are on our payroll, and wages and statutory contributions are handled by us."],
    ],
  },
  {
    slug: "technical-support",
    code: "02",
    title: "Technical Support Manpower",
    short: "Technical Support",
    tagline: "Technicians who keep the lights, lines and machines on.",
    img: "/img/technical.jpg",
    intro:
      "Electricians, plumbers, HVAC and maintenance technicians, IT and desktop support staff — placed on your site for scheduled maintenance and day-to-day breakdowns.",
    includes: [
      "Electricians, plumbers and multi-skilled technicians",
      "HVAC, DG set and utility operators",
      "IT helpdesk and desktop support engineers",
      "Preventive maintenance schedules and logs",
      "Shift-wise coverage for critical sites",
    ],
    faqs: [
      ["Do you provide certified technicians?", "We match technicians to the skills and certifications your site needs and share their profiles before deployment."],
      ["Can we hire on a project basis?", "Yes — we support both long-term deployment and short project or shutdown requirements."],
      ["What if a technician is unavailable?", "We arrange a trained replacement so your site coverage is not interrupted."],
    ],
  },
  {
    slug: "payroll-processing",
    code: "03",
    title: "Payroll Processing",
    short: "Payroll Process",
    tagline: "Salaries on time. Compliance on record.",
    img: "/img/payroll.jpg",
    intro:
      "End-to-end payroll processing — attendance to payslip — including PF, ESIC, professional tax, TDS and labour-law registers, so your HR team can focus on people.",
    includes: [
      "Monthly salary computation and payslips",
      "PF, ESIC, PT, LWF and TDS calculations and filings",
      "Attendance, leave and overtime integration",
      "Full & final settlements",
      "Statutory registers and MIS reports",
    ],
    faqs: [
      ["Do you need access to our HR software?", "We can work with your existing attendance data in any format, or run payroll fully on our side."],
      ["Is our data kept confidential?", "Payroll data is handled by a restricted team and shared only with your authorised contacts."],
      ["Can you take over mid-year?", "Yes. We onboard your existing records and continue from the current month."],
    ],
  },
  {
    slug: "scanning",
    code: "04",
    title: "Document Scanning",
    short: "Scanning",
    tagline: "Every page, captured clean and indexed right.",
    img: "/img/scanning.jpg",
    intro:
      "High-volume scanning of files, registers, ledgers, drawings and records — at your premises or ours — with quality checks and indexing so every page can be found again.",
    includes: [
      "On-site or off-site scanning teams",
      "A4, A3 and large-format document scanning",
      "Image clean-up, de-skew and quality checks",
      "File naming and indexing as per your structure",
      "Safe handling and return of original records",
    ],
    faqs: [
      ["Can scanning happen at our office?", "Yes. We set up equipment and operators on your premises if records cannot leave the site."],
      ["What output formats do you deliver?", "Searchable PDF, PDF/A, TIFF or JPEG — whatever your system requires."],
      ["How do you handle fragile documents?", "Old and fragile records are handled separately with suitable scanning methods."],
    ],
  },
  {
    slug: "digitization",
    code: "05",
    title: "Digitization & Data Entry",
    short: "Digitization",
    tagline: "From paper archives to searchable systems.",
    img: "/img/digitization.jpg",
    intro:
      "We turn scanned records into usable data — OCR, metadata tagging, data entry and upload into your document management system or cloud storage.",
    includes: [
      "OCR and searchable document creation",
      "Metadata tagging and data entry",
      "Upload to your DMS, ERP or cloud drive",
      "Data verification and accuracy checks",
      "Ongoing back-office digitization teams",
    ],
    faqs: [
      ["Do you also do the scanning?", "Yes — scanning and digitization can be taken as one project, or digitization alone on your existing scans."],
      ["Can you work with our software?", "We can upload into your existing system or deliver structured files ready for import."],
      ["How is accuracy ensured?", "Entries go through verification checks before delivery."],
    ],
  },
  {
    slug: "transport",
    code: "06",
    title: "Transport Services",
    short: "Transport",
    tagline: "Goods and people, moved on schedule.",
    img: "/img/transport.jpg",
    intro:
      "Goods transport and employee transportation with drivers, vehicles and route planning — for daily movements, project loads and scheduled staff pick-ups and drops.",
    includes: [
      "Goods transport for full and part loads",
      "Employee pick-up and drop services",
      "Drivers on deployment for company vehicles",
      "Route planning and trip records",
      "Coordination with warehouse dispatch",
    ],
    faqs: [
      ["Do you provide drivers only?", "Yes. We can deploy drivers for your own fleet, or supply vehicles with drivers."],
      ["Can transport be combined with warehousing?", "Yes — storage, dispatch and delivery can be planned together under one contract."],
      ["Do you handle employee commute?", "We plan routes and timings for staff pick-ups and drops as per your shifts."],
    ],
  },
  {
    slug: "warehousing",
    code: "07",
    title: "Warehousing",
    short: "Warehousing",
    tagline: "Inbound, stocked, picked, packed, dispatched.",
    img: "/img/warehousing.jpg",
    intro:
      "Warehouse operations and manpower — loaders, pickers, packers, inventory clerks and supervisors — to run inbound, storage and dispatch smoothly.",
    includes: [
      "Loading, unloading and material handling staff",
      "Picking, packing and dispatch teams",
      "Inventory counting and stock records",
      "Warehouse supervisors and shift leads",
      "Seasonal and peak-volume manpower",
    ],
    faqs: [
      ["Do you run the warehouse or just supply staff?", "Both. We can supply manpower to your warehouse or manage operations end-to-end."],
      ["Can you scale for peak season?", "Yes — tell us the expected volume and dates and we plan extra manpower in advance."],
      ["Do you maintain inventory records?", "We maintain stock records and share regular reports with your team."],
    ],
  },
  {
    slug: "storage",
    code: "08",
    title: "Storage Solutions",
    short: "Storage",
    tagline: "Records and goods, stored safe and retrievable.",
    img: "/img/storage.jpg",
    intro:
      "Secure storage for physical records, files and goods — boxed, labelled and tracked — with retrieval when you need a document back.",
    includes: [
      "Record and file box storage",
      "Barcode or label-based tracking",
      "Retrieval and return on request",
      "Goods and material storage",
      "Secure destruction of expired records on request",
    ],
    faqs: [
      ["How do we get a file back?", "Raise a retrieval request and we locate and send the file or a scanned copy."],
      ["Can stored records be digitized later?", "Yes — stored boxes can be scanned and digitized whenever you choose."],
      ["Is the storage secure?", "Access is restricted and every box is tracked from intake to retrieval."],
    ],
  },
];

export const getService = (slug) => SERVICES.find((s) => s.slug === slug);
